import { SLOT } from '@/admins/SmartReports/components/Layouts/types';
import {
  SmartReportComponentTypesEnum,
  SmartReportLayoutIdsEnum,
} from '@/admins/SmartReports/types';
import { BaseRowEdit, BaseRowThumbnail, BaseRowView } from './BaseRowLayout';

const layout = [[SLOT], [SLOT]];

const rootStyles = {
  display: 'grid',
  padding: '0.5rem 0.5rem 2.5rem 0.5rem',
  gap: '0.5rem',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '75px 1fr 1fr',
  '& > *': {
    minHeight: 0,
  },
};

const rootThumbnail = {
  ...rootStyles,
  padding: '0.2rem',
  gap: '0.1rem',
  gridTemplateRows: '10px 1fr 1fr',
};

const ComponentView = props => <BaseRowView layout={layout} rootStyles={rootStyles} {...props} />;

const ComponentEdit = () => <BaseRowEdit layout={layout} rootStyles={rootStyles} />;

const ComponentThumbnail = props => (
  <BaseRowThumbnail layout={layout} rootStyles={rootThumbnail} {...props} />
);

export const TwoRowLayout = {
  id: SmartReportLayoutIdsEnum.TwoRowSlots,
  title: 'Two Row Layout',
  description: 'A layout with title and two rows of one column each.',
  Thumbnail: ComponentThumbnail,
  Component: ComponentEdit,
  ComponentView,
  elementTypes: Object.values(SmartReportComponentTypesEnum),
};
